module.exports = __webpack_public_path__ + "static/media/black-bale.c69c454c.png";